const snakeyMousePlayerSpritesheet = {
  "name": "snakeyMousePlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/snakeyMousePlayerSpritesheet.png",
  "sprites": {
    "snakeyMousePlayerHead": [0],
    "snakeyMousePlayerBody": [1]
  }
}
export default snakeyMousePlayerSpritesheet;
